export const cartActionTypes = {
    SET_HIDDEN_STATE: 'SET_HIDDEN_STATE',
    ADD_ITEM: 'ADD_ITEM',
    DELETE_ITEM_FROM_CART: 'DELETE_ITEM_FROM_CART',
    REMOVE_ITEM: 'REMOVE_ITEM'
}